import routerOptions0 from "D:/W-S Projekte/WS_intern/Website-2.0/ws-website-2.0/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}